module.exports = __webpack_public_path__ + "img/dakcontrol.a11b8442.svg";